/**
 * 规整 PuppyCAD 导出文件基础名称。
 *
 * @param value 原始名称。
 * @returns 可用于下载的基础文件名称。
 */
export function normalizePuppyExportFileBaseName(value: string): string {
  const normalized = value
    .trim()
    .replace(/[\\/:*?"<>|]/g, '_')
    .replace(/\s+/g, '_')

  return normalized.length > 0 ? normalized : 'model'
}

/**
 * 生成离线包唯一 ID。
 *
 * @returns 包唯一 ID。
 */
export function createPuppyPackageId(): string {
  const randomId = typeof globalThis.crypto?.randomUUID === 'function'
    ? globalThis.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`
  return `puppy-${randomId}`
}

// 离线包与普通 sidecar 必须复用同一份内容摘要实现，避免协议身份校验发生漂移。
export { createSha256Hex } from '../../utils/hash/createSha256Hex'

/**
 * 将文本编码为 UTF-8 字节。
 *
 * @param value 输入文本。
 * @returns UTF-8 字节。
 */
export function encodeUtf8(value: string): Uint8Array {
  return new TextEncoder().encode(value)
}
